import * as Yup from 'yup'
import { cloneDeep } from 'lodash-es'

// Libs
import { handleNickNameFormatRegex } from '@/methods/handleFormatRegex'

// Constants
import { STORAGE_DATA } from '@/constants/storageData'

// PropTypes
type PropTypes = {
  setUsername: (payload: any) => void
  closeSettingUsernamePopup: () => void
  t: any
}

const formikConfig = (props: PropTypes) => {
  const { t, setUsername } = props

  return {
    initialValues: {
      username: '',
    },

    validationSchema: Yup.lazy(() => {
      return Yup.object().shape({
        username: Yup.string()
          .required(t('Field_Error_Required'))
          .test('nickNameFormat', t('LiveRoom_Portrait_Release_Agreement_Popup_Nickname_Format_Error'), (value) => handleNickNameFormatRegex(value)),
      })
    }),

    async onSubmit(data: any) {
      const cloneData = cloneDeep(data)

      // 所有品牌：送出前先清掉 local storage token，讓 usePCHomeUUID 一律走 fetchPchomeToken 重新換 token，
      // 不沿用舊 token 打 updateMemberData
      localStorage.removeItem(STORAGE_DATA.TOKEN)

      setUsername(cloneData.username)

      const newUuid = `${Date.now()}${Math.floor(Math.random() * 1000000)}`
      localStorage.setItem('pxuuid', newUuid)
    },

    enableReinitialize: true,
  }
}

export default formikConfig
